if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        const alreadyGiftExist = document.querySelector('.gift-item-d5');
      }

      getSelectedAddons() {
        const addons = [];
        
        // Check for checkbox addons (single variant products)
        const checkboxes = document.querySelectorAll('.addon-checkbox:checked');
        checkboxes.forEach(checkbox => {
          const variantId = checkbox.dataset.addonVariantId;
          if (variantId) {
            addons.push({
              id: variantId,
              quantity: 1
            });
          }
        });
        
        // Check for radio button addons (multi-variant products)
        const radioGroups = document.querySelectorAll('.addon-radio:checked');
        radioGroups.forEach(radio => {
          const variantId = radio.dataset.addonVariantId;
          if (variantId && radio.value !== '') {
            addons.push({
              id: variantId,
              quantity: 1
            });
          }
        });
        
        return addons;
      }

      async addAllItemsToCart(mainFormData, addonItems) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        
        const alreadyGiftExist = document.querySelector('.gift-item-d5');
        const giftElement = document.querySelector('.gift-product-id-d5'); 
        
        // We build the array in reverse. 
        // Items added LAST appear at the TOP of the cart drawer.
        const items = [];

        // 1. Put Gift at the bottom (if applicable)
        if (!alreadyGiftExist && giftElement && giftElement.getAttribute('data-variant')) {
            items.push({
                id: giftElement.getAttribute('data-variant'),
                quantity: 1
            });
        }

        // 2. Put Addons in the middle
        items.push(...addonItems);

        // 3. Put Main Product at the top
        items.push({
            id: mainFormData.get('id'),
            quantity: parseInt(mainFormData.get('quantity') || 1),
            properties: this.getFormProperties(mainFormData)
        });

        config.body = JSON.stringify({ 
          items: items,
          sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : undefined,
          sections_url: window.location.pathname
        });

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          return await response.json();
        } catch (error) {
          console.error('Error adding items to cart:', error);
          throw error;
        }
      }

      getFormProperties(formData) {
        const properties = {};
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const propName = key.match(/properties\[(.*?)\]/)[1];
            properties[propName] = value;
          }
        }
        return Object.keys(properties).length > 0 ? properties : undefined;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        
        // Get selected addon products
        const addonProducts = this.getSelectedAddons();

        // If we have addons, add everything together in one request
        if (addonProducts.length > 0) {
          this.addAllItemsToCart(formData, addonProducts)
            .then((response) => {
              if (response.status) {
                this.handleErrorResponse(response, formData);
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.handleSuccessResponse(response, formData, evt);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.finalizeSubmit(evt);
            });
        } else {
          // No addons, use original flow
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          const giftVariantId = document.querySelector('.gift-product-id-d5')?.getAttribute('data-variant');
      const alreadyGiftExist = document.querySelector('.gift-item-d5');

            if (giftVariantId && !alreadyGiftExist) {
              const index = formData.getAll('items[][id]').length;

              formData.append(`items[${index}][id]`, giftVariantId);
              formData.append(`items[${index}][quantity]`, 1);
            }

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorResponse(response, formData);
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.handleSuccessResponse(response, formData, evt);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.finalizeSubmit(evt);
            });
        }
      }

      handleErrorResponse(response, formData) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
      }

      handleSuccessResponse(response, formData, evt) {
        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;
        
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        }
      }

      finalizeSubmit(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        CartPerformance.measureFromEvent("add:user-action", evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}